import { checkDomain, getFranchiseDetails, handleCrossDomainLink, updateHeaderContent } from "./share";
import { REGEX } from "../constants/regex";
import { localizationTagLine, localizationTagUpadation } from "./localizationTag";
import { addLocalizationHeaderMenuLocal } from "../../global";
import { Footer } from "../footer/footer";
import { HeaderSwitch } from "./headerSwitch";
export class UserInfoHandler {
    private static instance: UserInfoHandler;

    private formIds: string[];
    private userDetailsKey: string;

    private constructor() {
        this.formIds = ['referral-form'];
        this.userDetailsKey = 'userDetails';
    }

    static getInstance(): UserInfoHandler {
        if (!UserInfoHandler.instance) {
            UserInfoHandler.instance = new UserInfoHandler();
        }
        return UserInfoHandler.instance;
    }

    setFormIds(formIds: string[]): void {
        this.formIds = formIds;
    }

    setUserDetailsKey(userDetailsKey: string): void {
        this.userDetailsKey = userDetailsKey;
    }

    async captureUserInfo(): Promise<void> {
        // Base64 string is passed as a URL parameter (userDetails)
        const urlParams = new URLSearchParams(globalThis.location.search);
        const userDetails = urlParams.get(this.userDetailsKey);

        for (const formId of this.formIds) {
            const formDom = document.querySelector(`#${formId}, .${formId}`);
            if (userDetails && formDom) {
                try {

                    const userData = this.decodeUserDetails(userDetails);
                    const isInvalidZip = this.isInvalidZipCode(userData);

                    if (!isInvalidZip && userData.zipcode !== '') {
                        await this.fetchFranchiseDetailsAndUpdate(userData.zipcode);
                    }
                    this.prefillFormWithUserData(formId, userData);
                } catch (error) {
                    console.warn(`Error decoding or parsing user details: ${error}`);
                    await this.addLocalizationAndUpdateHeader();
                }
            } else {
                await this.addLocalizationAndUpdateHeader();
            }
        }
    }
    // Check if the Zip code is valid based on the domain
    private isInvalidZipCode(userData: any): boolean {
        const isCaDomain = checkDomain() === 'ca';
        const zipPattern = isCaDomain ? REGEX.caSendZip : REGEX.sendZip;
        return userData.zipcode !== '' && !zipPattern.test(userData.zipcode.trim());
    }
    //  method to prefill form fields with user data
    private prefillFormWithUserData(formId: string, userData: any): void {
        const fieldMappings = this.getFieldMappings(formId, userData);
        this.prefillFormFields(fieldMappings);
    }
    private decodeUserDetails(userDetails: string): any {
        // Decode the Base64 string
        const decodedData = atob(userDetails);
        // Parse the decoded JSON data
        return JSON.parse(decodedData);
    }

    getFieldMappings(formId: string, userData: any) {
        // Check for the specific form ID. Change to switch case in future if multiple forms to be handled.As per Sonar suggetsion used if for now
        if (formId === 'referral-form') {
            return [

                { id: 'my-refer-fname', value: userData.firstName, regex: REGEX.sendName },
                { id: 'my-refer-lname', value: userData.lastName, regex: REGEX.sendLname },
                { id: 'my-refer-email', value: userData.email, regex: REGEX.sendEmail },
                { id: 'my-refer-phone', value: userData.phone, regex: REGEX.mobileNumberRegex },
                { id: 'my-refer-zip-code', value: userData.zipcode, regex: REGEX.sendZip }
            ];
        }
        // Default case (if the formId is anything other than 'referral-form')
        return [];
    }

    private formatAndValidatePhone(phone: string): string | null {
        if (!phone) return null;
        const digits = phone.replace(/\D/g, '');
        if (digits.length !== 10) return null;
        const reg = REGEX.mobileNumberRegex;
        const match = digits.match(reg);
        if (!match) return null;
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    updateInputValue(inputId: string, value: string | number | null | undefined) {
        try {
            const hiddenInput = document.getElementById(inputId) as HTMLInputElement | null;

            if (hiddenInput && value !== null && value !== undefined) {
                hiddenInput.value = value.toString();
            }
        } catch (error) {
            console.warn(`Error in updateInputValue function: ${error}`);
        }
    }

    async fetchFranchiseDetailsAndUpdate(zipCode: string): Promise<void> {
        try {
            const response = await getFranchiseDetails(zipCode);
            const result = response;

            if (result.length > 0) {
                localStorage.setItem("franchiseWebLocationId", result[0].franchiseWebLocationId);
                await this.setLocalDataReferForm(result[0], zipCode);
            }
        } catch (error) {
            console.warn("Error fetching franchise details:", error);
        } finally {
            await this.addLocalizationAndUpdateHeader();
        }
    }

    prefillFormFields(fieldMappings: any[]): void {

        fieldMappings.forEach(mapping => {
            if (mapping.regex.test(mapping.value)) {
                const field = document.getElementById(mapping.id) as HTMLInputElement | null;
                if (!field) return;
                // phonenumber to format before setting the value
                if (mapping.id === 'my-refer-phone') {
                    const formattedPhone = this.formatAndValidatePhone(mapping.value);
                    if (formattedPhone) {
                        field.value = formattedPhone;
                    }
                    return;
                }
                if (field) field.value = mapping.value;
            }
        });
    }

    async setLocalDataReferForm(data: any, zipCode: string): Promise<void> {
        if (data) {
            const { franchiseWebLocationId, doingBusinessAs, locationWebsiteUrl, websiteTracking } = data;
            localStorage.setItem("franchiseWebLocationId", franchiseWebLocationId);
            sessionStorage.setItem('franchiseId', franchiseWebLocationId);
            localStorage.setItem('doingBusinessAs', doingBusinessAs);
            sessionStorage.setItem('redirectionURL', locationWebsiteUrl);
            localStorage.setItem('weblocationId', franchiseWebLocationId);
            const locationUrl = locationWebsiteUrl?.replace(/\/$/, '') ?? '';
            const splitUrlArr = locationUrl.toLowerCase().split("/");
            const pathname = splitUrlArr[splitUrlArr.length - 1];

            // Handled the cross domain link for the location URL
            handleCrossDomainLink(locationUrl);

            localStorage.setItem('localPhoneNumber', websiteTracking);

            const phoneNO: any = document.querySelector('.header-wrapper .form-call-cta');
            if (phoneNO) {
                phoneNO.href = `tel:${websiteTracking}`;
                const reg = /(\d{0,3})(\d{0,3})(\d{0,4})/;
                const phoneFormat: any = String(websiteTracking)?.replace(/\D/g, '').match(reg);
                phoneNO.innerHTML = `(${phoneFormat[1]}) ${phoneFormat[2]}-${phoneFormat[3]}`;
            }

            const mobile: any = document.querySelector('.header-cta-mobile .primary-btn');
            if (mobile) {
                mobile.href = `tel:${websiteTracking}`;
            }

            if (pathname) {
                localStorage.setItem('dbaName', pathname);
                localizationTagUpadation();
            }

            this.updateInputValue("local_weblocationId", franchiseWebLocationId);
            this.updateInputValue("weblocationId", franchiseWebLocationId);
            this.updateInputValue("full_dbaName", pathname);
            this.updateInputValue("dbaName", pathname);

            const address = document.querySelector('.header-wrapper .address');
            const desc = document.querySelector('.header-wrapper .description');

            if (doingBusinessAs) {
                updateHeaderContent(doingBusinessAs);
            }

            if (address && desc) {
                address.innerHTML = doingBusinessAs;
                localizationTagLine();
            }

            const addressEntered: any = (document.getElementById('user-service-address') as HTMLInputElement)?.value;
            sessionStorage.setItem("manualEnteredAddress", addressEntered + ", " + zipCode);
            sessionStorage.setItem("RL_Weblocation_ID", franchiseWebLocationId);
            sessionStorage.setItem("RL_DBAName", doingBusinessAs);

            this.hideGlobalBrandElements();
            Footer.init();
        }
    }

    hideGlobalBrandElements() {
        const globalBrandLogo = document.querySelector(".brand-header .brand-logo-wrapper") as HTMLElement;
        const globalfindLocal = document.querySelector(".brand-header .find-local") as HTMLElement;
        if (globalBrandLogo) { globalBrandLogo.style.display = "none"; }
        if (globalfindLocal) { globalfindLocal.style.display = "none"; }
    }

    async addLocalizationAndUpdateHeader(): Promise<void> {
        await addLocalizationHeaderMenuLocal();
        //localised Header in national
        HeaderSwitch.getInstance();
    }
}

